<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label for="contact">관리자 연락처</label>
          <input type="text" class="form-control" id="contact" placeholder=""
                 v-model.trim="user.contact"
                 name="contact"
                 v-validate="'required'"
                 :class="{'is-invalid': errors.has('contact')}">
          <div class="invalid-feedback" v-if="errors.has('contact')">
            <template v-if="errors.firstRule('contact') === 'required'">
              필수 입력항목입니다.
            </template>
            <template v-else-if="errors.firstRule('contact') === 'numeric'">
              숫자만 입력하세요.
            </template>
            <template v-else-if="errors.firstRule('contact') === 'mobile'">
              잘못된 연락처입니다.
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center my-5">
      <button type="button" class="btn btn-outline-secondary mx-2" @click="submit">저장</button>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AdminContact',
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async submit() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      this.$axios.post('/admin/user/contact', this.user.contact)
        .then(({ data }) => {
          this.$store.commit('setUser', data);
          // eslint-disable-next-line no-alert
          alert('변경되었습니다.');
        })
        .catch(() => {
          // eslint-disable-next-line no-alert
          alert('실패했습니다.');
        });
    },
  },
};
</script>

<style scoped>

</style>
